export function retryUntil(readyCondition: () => boolean, onReadyConditionPassed: () => void, onFailure: () => void): void {
  let retriesRemaining: number = 20;

  const retryInterval: ReturnType<typeof setInterval> =
    setInterval(
      () => {
        if (readyCondition()) {
          clearInterval(retryInterval);
          onReadyConditionPassed();
        } else if (retriesRemaining < 1) {
          clearInterval(retryInterval);
          onFailure();
        }

        retriesRemaining -= 1;
      },
      100
    );
}
